<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2 class="app-dialog__heading"></h2>
  <button mat-icon-button mat-dialog-close type="button" aria-label="Zamknij">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div class="confirm-dialog">
    <div class="confirm-dialog__icon">
      <ng-container *ngIf="customIcon">
        <mat-icon [svgIcon]="customIcon"></mat-icon>
      </ng-container>

      <ng-container *ngIf="confirmation && !customIcon">
        <mat-icon>help</mat-icon>
      </ng-container>

      <ng-container *ngIf="!confirmation && !customIcon">
        <mat-icon svgIcon="save"></mat-icon>
      </ng-container>

    </div>
    <p
      [innerHTML]="title | translate : { prop: dialogData?.translateProps }"
      [ngClass]="{ 'center-paragraph': centerText }"
      class="confirm-dialog__paragraph"></p>
  </div>
</div>

<div mat-dialog-actions fxLayoutAlign="center center" fxLayoutGap="10px">
  <ng-container *ngIf="confirmation; else confirmed">
    <button class="button button--small button--secondary" mat-dialog-close>{{ closeButton | translate }}</button>
    <button (click)="onClose()" class="button button--small button--primary">{{ successButton | translate }}</button>
  </ng-container>

  <ng-template #confirmed>
    <button class="button button--small button--primary" mat-dialog-close>{{ okButton | translate }}</button>
  </ng-template>
</div>

